var render = function() {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper-content",
    {
      class: _vm.$style.stepperContent,
      attrs: { step: _vm.currentCategory.orderIndex }
    },
    [
      _c("div", { class: _vm.$style.orderMain }, [
        _c("div", { class: _vm.$style.orderPrice }, [
          _vm._v("Item Price " + _vm._s(_vm._f("toPrice")(_vm.price)))
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.orderMainInfo }, [
          _c(
            "div",
            { class: _vm.$style.backBtnContainer },
            [
              _c(
                "BaseButton",
                {
                  class: [
                    _vm.$style.orderBackBtn,
                    ((_obj = {}), (_obj[_vm.$style.hide] = _vm.first), _obj)
                  ],
                  attrs: { "button-style": "Back" },
                  on: { click: _vm.previousStep }
                },
                [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.backIcon,
                    attrs: { symbol: "straight-arrow" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Back")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.orderMainCenter },
            [
              _c("OrderPreview", {
                attrs: { "current-category-key": _vm.categoryKey }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.nextBtnContainer },
            [
              _vm.last
                ? _c(
                    "BaseButton",
                    {
                      class: [
                        _vm.$style.orderNextBtn,
                        ((_obj$1 = {}),
                        (_obj$1[_vm.$style.fullWidth] = _vm.first),
                        _obj$1)
                      ],
                      attrs: {
                        disabled: _vm.nextDisabled,
                        "button-style": "Main"
                      },
                      on: { click: _vm.nextStep }
                    },
                    [_c("span", [_vm._v("Done")])]
                  )
                : _c(
                    "BaseButton",
                    {
                      class: [
                        _vm.$style.orderNextBtn,
                        ((_obj$2 = {}),
                        (_obj$2[_vm.$style.fullWidth] = _vm.first),
                        _obj$2)
                      ],
                      attrs: {
                        disabled: _vm.nextDisabled,
                        "button-style": "Main"
                      },
                      on: { click: _vm.nextStep }
                    },
                    [
                      _c("span", [_vm._v("Next")]),
                      _vm._v(" "),
                      _c("svg", {
                        directives: [{ name: "svg", rawName: "v-svg" }],
                        class: _vm.$style.nextIcon,
                        attrs: { symbol: "straight-arrow" }
                      })
                    ]
                  )
            ],
            1
          )
        ]),
        _vm._v(" "),
        !_vm.shouldHideStep
          ? _c("div", { class: _vm.$style.orderMainStep }, [
              _vm._v(
                "\n      Step " +
                  _vm._s(_vm.currentCategory.orderIndex) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.$style.orderMainTitle }, [
          _c("h2", [
            _vm._v("Choose Your\n        "),
            _c("span", { class: _vm.$style.orderTitleName }, [
              _vm._v(
                "\n          " + _vm._s(_vm.currentCategory.name) + "\n        "
              )
            ]),
            _vm._v(" "),
            _vm.currentCategoryQuantity > 0
              ? _c("span", { class: _vm.$style.orderTitleNumber }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentCategoryQuantity) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.currentCategory.note
            ? _c("p", { class: _vm.$style.categoryNote }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.currentCategory.note) + "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.configuratorGrid },
          [
            _vm._l(_vm.sortedItems, function(itemKey, index) {
              return _c("ConfiguratorOption", {
                key: index + "-option",
                class: _vm.configuratorItemStyle,
                attrs: { "item-key": itemKey, "category-key": _vm.categoryKey },
                on: { selected: _vm.itemSelected }
              })
            }),
            _vm._v(" "),
            !_vm.isDrinkProduct ? _c("ConfiguratorHelpButton") : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("ConfiguratorMobileButtons", {
        attrs: {
          first: _vm.first,
          last: _vm.last,
          "done-disable": _vm.doneDisabled,
          "next-disable": _vm.nextDisabled
        },
        on: { next: _vm.nextStep, back: _vm.previousStep }
      }),
      _vm._v(" "),
      _vm.isLoading ? _c("LoadingSpinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorStepContent.vue?vue&type=template&id=769ac356&
// module id = null
// module chunks = 